import AppBtn from '../app-btn'
import AppCounter from '../app-counter'
import AppYoutube from '../app-youtube'

export default
{
    name: 'app-carousel-3d-slide',

    components:
    {
        AppBtn,
        AppCounter,
        AppYoutube
    },

    data()
    {
        return {
            videoPlayedOnce: false
        }
    },

    props:
    {
        content: {
            type: Object,
            default()
            {
                return {}
            }
        },
        index: { type: Number, default: 0 },
        isCurrent: { type: Boolean, default: false }
    },

    computed:
    {
        hasVisual()
        {
            return this.content.image || this.content.video
        },

        hasDescription()
        {
            return !!this.content.description
        }
    },

    watch:
    {
        isCurrent: '_onIsCurrentChange'
    },

    created()
    {
        this.youtubePlayer = null
    },

    mounted()
    {
        if (this.isCurrent)
        {
            this.initJWPlayer()
        }
    },

    destroyed()
    {
        if (this.jwPlayer)
        {
            this.jwPlayer.remove()
        }
    },

    methods:
    {
        _onVideoClick()
        {
            this.$root.openModalVideo(this.content.video.type, this.content.video.id, this.content.video.url)
        },

        _onIsCurrentChange(value)
        {
            if (!value)
            {
                this.videoPlayedOnce = false
            }
            else
            {
                this.initJWPlayer()
            }
        },

        _onSlideClick(event)
        {
            if (!this.isCurrent)
            {
                event.preventDefault()
                this.$emit('click', this.index)
            }
        },

        _onYoutubeReady(player)
        {
            this.youtubePlayer = player
        },

        _onYoutubePlay()
        {
            this.videoPlayedOnce = true
        },

        _onJWPlayerPlay()
        {
            this.videoPlayedOnce = true
        },

        _onPreviewClick()
        {
            if (this.youtubePlayer)
            {
                this.youtubePlayer.player.playVideo()
            }

            if (this.jwPlayer)
            {
                this.jwPlayer.play()
            }
        },

        initJWPlayer()
        {
            // No JW Player
            if (!this.content.video || this.content.video.type !== 'jwplayer')
            {
                return
            }

            // Instanciate JW Player
            const jwplayer = window.jwplayer
            if (jwplayer)
            {
                window.setTimeout(() =>
                {
                    this.$jwPlayer = this.$el.querySelector('.js-jwplayer')

                    this.jwPlayer = window.jwplayer(this.$jwPlayer)

                    this.jwPlayer = this.jwPlayer.setup({
                        file: this.content.video.url,
                        mediaid: this.content.video.id,
                        autostart: true,
                        mute: true
                    })

                    this.jwPlayer.on('play', () =>
                    {
                        this._onJWPlayerPlay()
                    })
                }, 100)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-carousel-3d-slide/script.js